<script setup lang="ts">import { ref as _ref } from 'vue';

import CartButton from './CartMenu/CartButton.vue'
import CartTitle from './CartMenu/CartTitle.vue'
import Cart from './CartMenu/Cart.vue'

const open = _ref(false)
</script>

<template>

  <div class="flex gap-5 items-center text-v2-tertiary">
    <div class="relative">
      <CartButton @click="open = !open"/>

      <GMobileModal v-model:open="open">
        <template #header>
          <CartTitle class="text-center"/>
        </template>

        <Cart class="-mt-6" @click="open = false"/>
      </GMobileModal>
    </div>
  </div>
</template>
